export default "__VITE_ASSET__BPbpfOY2__"